module.exports = __webpack_public_path__ + "img/yano_Q_400_15_4.d50253ba.png";